import { useState } from "react";
import useHttp from "./useHttp";
// import { toast } from "react-toastify";

export default function useOrder() {
  const { HttpService } = useHttp();
  const [orderLoadings, setOrderLoadings] = useState({
    getExpiredOrders: false,
  });
  const [alertModal, setAlertModal] = useState(false);

  const [expiredOrders, setExpiredOrders] = useState([]);

  const seenOrder = async (order_id) => {
    try {
      const response = await HttpService.post("/api/v1.1/order/seen", {
        order_id,
      });
      if (response.status === 200) {
        setAlertModal(true);
      }
    } catch ({ err, response }) {}
  };

  const getExpiredOrders = async () => {
    try {
      setOrderLoadings({ ...orderLoadings, getExpiredOrders: true });
      const response = await HttpService.post("/api/v1.0/orders", {
        complainted_count: "1",
        doing_count: "1",
        done_count: "1",
        include: "service,address.location,user,details",
        notified: "1",
        status: "4",
        expired_orders: "1",
      });
      setOrderLoadings({ ...orderLoadings, getExpiredOrders: false });
      setExpiredOrders(response.data.data);
    } catch ({ err, response }) {
      setOrderLoadings({ ...orderLoadings, getExpiredOrders: false });
    }
  };

  const exports = {
    seenOrder,
    getExpiredOrders,
    expiredOrders,
    alertModal,
    setAlertModal,
    orderLoadings,
  };

  return exports;
}
